module.exports = __webpack_public_path__ + "img/91.6fa81e78.jpg";